import { monthsShort } from "moment";
import { resourcesEquivalences, trasactionalResourcesData } from "../../view/Common/NomenclatureItems";

type Risk = {
  nameRiskType: string;
  [key: string]: any;
};

type Subproduct = {
  componentNumber: string;
  [key: string]: any;
};

export const mapGeneralInfoInDataSource = (data) => {
  return { ...data?.sectionOneGeneralInformation, typeReport: data?.typeReport, creationDate: data?.creationDate };
}

export const getShortMonths = () => {
  return monthsShort().map(month => { return month.slice(0, 3).toUpperCase() });
}

export const mapChartDisbursementAnnual = (initialData, item) => {
  const mappedData: number[] = [];
  for (let monthIndex = 1; monthIndex <= 12; monthIndex++) {
    const record = initialData?.find(record => record.monthTransactionDate === monthIndex);

    if (record) {
      mappedData.push(record[item]);
    }
    else {
      mappedData.push(0);
    }
  }

  return mappedData;
}

export const mapResourcesDataSource = (originData) => {
  const { labels } = trasactionalResourcesData;
  const totalData = originData.find(d => d.fundingSource === "TOTAL");

  const mapDataByLabel = (property) =>
    labels.map(label => {
      const fundingSource = resourcesEquivalences[label];
      const mapData = originData.find(record => record.fundingSource === fundingSource);
      return mapData ? mapData[property] : 0;
    });

  const expenditures = mapDataByLabel('expendituresA');
  const commitments = mapDataByLabel('commitmentB');
  const balances = mapDataByLabel('balanceCMinusBPlusA');

  const totals = totalData ? [
    totalData.expendituresA,
    totalData.commitmentB,
    totalData.balanceCMinusBPlusA
  ] : [0, 0, 0];

  const datasets = [
    { ...trasactionalResourcesData.datasets[0], data: expenditures },
    { ...trasactionalResourcesData.datasets[1], data: commitments },
    { ...trasactionalResourcesData.datasets[2], data: balances }
  ];

  return {
    ...trasactionalResourcesData,
    datasets,
    totals
  };
};

export const mapProductDataSource = (product) => {
  return {
    description: product.description,
    items: [
      {
        component: 'P(a)',
        phisical: { current: product.itemProductConverts[0]?.physicalPlanned_AF_PA || 0, projectEnd: product.endProject_AF_PA },
        financial: { current: product.itemProductConverts[0]?.financialPlanned_AFI_PA || 0, projectEnd: product.endProject_AFI_PA }
      },
      {
        component: 'A',
        phisical: { current: product.itemProductConverts[0]?.physicalActual_AF_A || 0, projectEnd: product.endProject_AF_A },
        financial: { current: product.itemProductConverts[0]?.financialActual_AFI_A || 0, projectEnd: product.endProject_AFI_P }
      }
    ]
  }
}

export const mapInitialCheckSections = (sections) => {
  return sections.map((card, index) => ({
    ...card,
    checked: true,
    isDragging: index !== 0
  }))
}

export const groupRisksByCategory = (risks: Risk[]) => {
  const grouped = risks.reduce<Record<string, { nameRiskType: string; risks: Risk[] }>>(
    (acc, risk) => {
      if (!acc[risk.nameRiskType]) {
        acc[risk.nameRiskType] = {
          nameRiskType: risk.nameRiskType,
          risks: []
        };
      }
      acc[risk.nameRiskType].risks.push(risk);
      return acc;
    },
    {}
  );

  return Object.values(grouped).sort(
    (a, b) => b.risks.length - a.risks.length
  );
};

export const getComponentBalancesDataSource = (data) => {
  let dataSource: any[] = [];

  data.map((component) => {
    component.componentBalancesDetails.map((subproduct) => {
      const mappedSubproduct = {
        ...subproduct,
        componentNumber: component.componentNumber
      };

      dataSource.push(mappedSubproduct);
    })
  })

  return dataSource;
}

export const groupProcessProductsByComponent = (subproducts: Subproduct[]) => {
  const grouped = subproducts.reduce<Record<string, { componentNumber: string; subproducts: Subproduct[] }>>(
    (acc, subproduct) => {
      if (!acc['component_' + subproduct.componentNumber]) {
        acc['component_' + subproduct.componentNumber] = {
          componentNumber: subproduct.componentNumber,
          subproducts: []
        };
      }
      acc['component_' + subproduct.componentNumber].subproducts.push(subproduct);
      return acc;
    },
    {}
  );

  return Object.values(grouped);
};